import type { FetchAddonApi } from 'epic/postTradeOperations/addon/fetchAddonFormEpic';
import type { FetchMergedDealsApi } from 'epic/postTradeOperations/addon/fetchMergedDealsEpic';
import type { AddonFormResult, MergeDeal } from 'models/forms/AddonFormResult';
import type { DealSplitData } from 'models/forms/DealSplitData';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http.old/httpClient.model';
export type AddonApi = FetchAddonApi;

function mapPayload(payload: any): AddonFormResult {
  const mapCustodian = ({ id, label, eliotCode }: { id: string; label: string; eliotCode: string }) => ({
    id,
    label,
    eliotCode,
  });

  const mapDealSplit = ({
    custodian,
    notionalAmountInGrid,
  }: {
    custodian: string;
    notionalAmountInGrid: number;
  }): DealSplitData => ({ Custodian: custodian, NotionalAmountInGrid: notionalAmountInGrid });

  return {
    ...payload,
    custodians: {
      ...payload.custodians,
      data: payload.custodians.data?.map(mapCustodian),
    },
    dealSplit: payload.dealSplit.map(mapDealSplit),
    tradeClientSide: payload.tradeClientSide?.toLowerCase(),
  };
}

type MergeableDealsResponse = {
  mergeableDeals: ReadonlyArray<MergeDeal>;
};

export function addonApi(http$: IHttpClient): AddonApi & FetchMergedDealsApi {
  return {
    fetchFormValues(tabId: string, productId: string, rfqId: string): Observable<AddonFormResult> {
      return http$
        .getJSON<AddonFormResult>({
          url: `api/v2/addon-form/${tabId}/default/${productId}?rfqId=${rfqId}`,
        })
        .pipe(map(({ payload }) => mapPayload(payload)));
    },
    fetchMergedDeals(productId: string): Observable<ReadonlyArray<MergeDeal>> {
      return http$
        .getJSON<MergeableDealsResponse>({
          url: `api/v1/mergeable-deals/${productId}`,
        })
        .pipe(map(({ payload }) => payload.mergeableDeals));
    },
  };
}
